<template>
	<div v-if="showaiWfdShow">
		<div class="fadein_bind WFD">
			<div class="box" style="width: 600px;">
				<div class="head">
					<p>{{$t('aipf')}}</p>
					<img src="@/assets/images/close_03.png" @click="back" class="close" />
				</div>
				<div class="airank">
					<div class="item">
						<p>{{$t('bencixiezuo')}}</p>
						<div class="contents on">{{aiData.text}}</div>
					</div>
					<div class="item">
						<p>{{$t('bencipf')}}</p>
						<div class="total">
							<div class="frs" style="padding-left: 20px;">
								<div class="jds">
									<div class="icon">
										<span>{{$t('zhunquedu')}}</span>
										<img src="@/assets/images/whs_03.png"  @click="showDesc('ch')"/>
									</div>
									<div class="jd">
										<div :style="`width: ${aiData.score/aiData.totalScore*100}%`"></div>
									</div>
									<span><em>{{aiData.score}}<i>/{{aiData.totalScore}}</i></em></span>
								</div>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="h">
							<p>{{$t('zuodainfo')}}</p>
							<div class="desc">
								<div>{{$t('zhengquede')}}</div>
								<div class="on1">{{$t('queshide')}}</div>
								<div class="on">{{$t('cuowude')}}</div>
							</div>
						</div>
						<div class="daan">
							<div class="heads">
								<p>{{$t('daan')}}</p>
								<span>{{aiData.answer?aiData.answer:'暂无'}}</span>
							</div>
							<div class="ls">
								<p>{{$t('aishibie')}}</p>
								<ul class="ws">
									<li :class="item.status == 1?'on':item.status == 2?'on1':''" v-for="(item, index) in aiData.wfdResult">{{item.word}}</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="button" style="margin-top: 28px;">
						<div class="on" @click="back">{{$t('back')}}</div>
						<div @click="back">{{$t('queding')}}</div>
					</div>
				</div>
			</div>
		</div>
		<AiDesc :descFont="descFont"></AiDesc>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'aiWfdShow',
		props: ['aiData'],
		data() {
			return {
showbox: true,
				descFont: {}
			}
		},
		computed: {
			showaiWfdShow() {
				return this.$store.state.showaiWfdShow;
			}
		},
		methods: {
			showDesc(type){
//				if(type == 'nr'){
					this.descFont = {
						title: '内容',
						desc: `2 Provides a good summary of the text. All relevant aspects mentioned</br>1 Provides a fair summary of the text but misses one or two aspects</br>0 Omits or misrepresents the main aspects of the text</br>答题建议</br>一般来说，多段式的 SWT 文章，一个段落有一个关键点。整篇下来，关键点在 4 个左右。`
					}
//				}
				this.$store.commit("showaiDESCShow", true);
			},
			back() {
				this.$store.commit("showaiWfdShow", false);
			},
		},
	}
</script>

<style lang="less" scoped>
	.fadein_bind .box .airank .item .daan .ls ul.ws li{
		padding: 0 !important;
		height: auto;
		margin: 0;
		background: none !important;
		border: none !important;
		color: #1991bf;
		width: auto;
		min-width: auto;
		margin-right: 4px;
	}
	.fadein_bind .box .airank .item .daan .ls ul.ws li.on1{
		color: #BBD24F;
	}
	.fadein_bind .box .airank .item .daan .ls ul.ws li.on{
		color: #E60053;
		text-decoration: line-through;
	}
</style>


// WEBPACK FOOTER //
// src/components/ai-wfd.vue